import React, { Component } from 'react'
import Slider from 'react-slick'

class Partners extends Component {

    render() {
        if (this.props.partners.loading) {
            return 'Loading...'
        };
        if (this.props.partners.error) {
            return 'Error fetch data';
        }
        let partners = this.props.partners.partners;
        let partnerElement = partners.map(partner => {
            return (
                <li key={partner.id}><a target="_blank" href={partner.url}><img className="partner-image" src={partner.logo} alt={partner.name}/></a></li>
            );
        });

        const settings = {
            dots: false,
            infinite: true,
            speed: 100,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,
        };

        return (
            <div>
                <div className="block-index-partner">
                    <div className="container">
                        <div className="block-index-title text-blue">Đối tác</div>
                        <ul className="list-inline marginB0 text-center list-partner partner-area">
                            <Slider {...settings}>
                                {partnerElement}
                            </Slider>
                        </ul>
                    </div>
                </div>
                <div className="block-index-download-app">
                    <div className="container">
                        <div className="block-index-title text-blue">Tải app</div>
                        <div className="text-center ">
                            <img src="images/app1.png" alt="" className="img-app1"/>
                            <img src="images/app2.jpg" alt="" className="img-app2"/>
                            <img src="images/app3.jpg" alt="" className="img-app3"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Partners



// WEBPACK FOOTER //
// ./src/components/Partners.js